import { Injectable } from '@angular/core';
import { Apollo, QueryRef } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TenantActionsDocument, TenantActionsQuery } from 'src/app/core/graphql/generated/gen-types';

export type TenantActionItem = TenantActionsQuery['tenantActions'][number];

@Injectable({ providedIn: 'root' })
export class TenantActionsService {
	private queryRef: QueryRef<TenantActionsQuery>;

	constructor(private apollo: Apollo) {}

	getTenantActions(): Observable<TenantActionItem[]> {
		if (!this.queryRef) {
			this.queryRef = this.apollo.watchQuery<TenantActionsQuery>({
				query: TenantActionsDocument,
				pollInterval: 60_000,
				fetchPolicy: 'cache-and-network',
			});
		}
		return this.queryRef.valueChanges.pipe(map((result) => result.data?.tenantActions ?? []));
	}

	refetch(): void {
		this.queryRef?.refetch();
	}
}
